import EmailSettings from '@/admin/pages/settings/email-settings';
import { settingsQuery } from '@/admin/queries/settings';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/email')({
	loader: ({ context }) => context.queryClient.ensureQueryData(settingsQuery()),
	component: EmailSettings,
});
